import { useState, useRef } from 'react'
import { Inline } from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from '../../components/Icon'
import * as S from './styled'

const Accordion = ({ title, text, counter }) => {
  const [active, setActive] = useState(false)
  const [height, setHeight] = useState('0')

  const content = useRef(null)

  const toggleActive = () => {
    setActive((state) => !state)
    setHeight(active ? 0 : `${content.current.scrollHeight}px`)
  }

  return (
    <S.AccordionItem>
      <S.WrapperTitle onClick={toggleActive}>
        <Inline spacing="mega" justify="left">
          <S.Title size="mega" noMargin>
            {counter}.
          </S.Title>
          <S.Title size="mega" noMargin>
            {title}.
          </S.Title>
        </Inline>

        <S.ContentIcon>
          <Icon name="arrow-down" />
        </S.ContentIcon>
      </S.WrapperTitle>

      <S.Content style={{ maxHeight: height }} ref={content}>
        <S.ContentText
          size="mega"
          noMargin
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      </S.Content>
    </S.AccordionItem>
  )
}

export default Accordion
